<div
  data-at-notification
  class="vi-notification justify-center items-{{ layoutAlign }}"
  [ngClass]="type"
  [class.shadow]="shadow"
  [class.clickable]="clickable"
  [class.dismissible]="dismissible"
>
  <div class="flex flex-row gap-[14px] justify-center items-center flex-[100%] max-w-[100%]">
    <div class="icon flex flex-col justify-center items-center flex-[36px] max-w-[36px]">
      <div class="flex flex-row justify-center items-center flex-[36px] max-w-[36px]">
        <mat-icon>{{ icon }}</mat-icon>
      </div>
    </div>
    <div data-at-notification-message class="message" [class.bold]="bold">
      <ng-content></ng-content>
    </div>
  </div>
  <div *ngIf="dismissible" class="close-btn-container">
    <vi-icon-button (click)="onClose()"> close </vi-icon-button>
  </div>
</div>
